import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "./AdminLayout";

export default function Login() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      login(data.token, data.user);
      nav("/admin");
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="admin-root min-h-screen bg-[#F8F7F4] flex items-center justify-center px-4">
      <form onSubmit={submit} className="bg-white w-full max-w-sm rounded-lg shadow-sm border border-stone-200 p-8" data-testid="admin-login-form">
        <img src="/assets/logo.jpg" alt="IHD" className="h-10 w-auto mb-6" />
        <h1 className="text-xl font-bold mb-1 flex items-center gap-2"><Lock className="w-4 h-4 text-crimson" />Admin Portal</h1>
        <p className="text-sm text-stone-500 mb-6">Sign in to manage the directory.</p>
        <label className="text-sm font-bold block mb-1">Email</label>
        <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="w-full border border-stone-300 rounded-md px-3 py-2 mb-4 text-sm outline-none focus:ring-2 focus:ring-crimson/30" data-testid="admin-login-email" />
        <label className="text-sm font-bold block mb-1">Password</label>
        <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="w-full border border-stone-300 rounded-md px-3 py-2 mb-4 text-sm outline-none focus:ring-2 focus:ring-crimson/30" data-testid="admin-login-password" />
        {error && <p className="text-sm text-red-600 mb-4" data-testid="admin-login-error">{error}</p>}
        <button disabled={busy} className="w-full bg-crimson hover:bg-crimson-hover text-white font-bold rounded-md py-2.5 text-sm flex items-center justify-center gap-2 disabled:opacity-60" data-testid="admin-login-submit">
          {busy && <Loader2 className="w-4 h-4 animate-spin" />}Sign in
        </button>
      </form>
    </div>
  );
}
